import CareersPage from "../components/pages/Careers";

export default CareersPage;
